import Config from './config'
import Routes from './routes'
import Links from './links'
import Launcher from './launcher'

export default {
  Config,
  Launcher,
  Routes,
  Links,
}
